module.exports = __webpack_public_path__ + "img/addCardBg.4733feb8.png";